import React, { Component } from 'react';
import { Icon } from "@iconify/react";
import ButtonLoader from '../../components/common/buttonLoader/ButtonLoader';
import LogoImage from "../../images/logo.png";
import { Navigate } from 'react-router-dom';
import { isValidForm, validate } from '../../utils/validation/CommonValidator';
import { ErrorMessage } from '../../utils/Messages';
import ValidationText from '../../utils/validation/ValidationText';
import AuthenticationServices from '../../services/axiosServices/apiServices/AuthenticationServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { decryptionAPI } from '../../utils/Encryption';
export default class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.adminServices = new AuthenticationServices();
        this.swalServices = new SwalServices();
        this.state = {
            route: "",
            isLoading: false,
            adminId: 0,
            showPassword: false,
            showConfirmPassword: false,
            passwordDetails: {
                password: "",
                confirmPassword: "",
                adminID: 0,
            },
            validationRules: {
                password: [
                    {
                        type: "require",
                        message: ErrorMessage.FieldRequired.replace("{0}", "password"),
                    },
                    {
                        type: "password",
                        message: ErrorMessage.PasswordFormat,
                    },
                ],
                confirmPassword: [
                    {
                        type: "require",
                        message: ErrorMessage.FieldRequired.replace("{0}", "confirm password"),
                    },
                    {
                        type: "compare",
                        compareEle: "password",
                        message: ErrorMessage.ComparePassword,
                    },


                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }
    componentDidMount() {
        // let urlString = new URLSearchParams(window.location.href);
        // let paramString = urlString.split('?')[1];
        let queryString = new URLSearchParams(window.location.search);
        for (let pair of queryString.entries()) {
            if (pair[0] === "secret") {

                let req = {
                    isEnType: true,
                    responseData: atob(pair[1]),
                    responseType: 1,
                };
                pair[1] = decryptionAPI(req);
                this.setState({ adminId: pair[1] });
            }
        }

    }

    // getParameters() {
    //     let urlString =
    //         "https://www.example.com/login.php?a=GeeksforGeeks&b=500&c=Hello Geeks";
    //     let paramString = urlString.split('?')[1];
    //     let queryString = new URLSearchParams(paramString);
    //     for (let pair of queryString.entries()) {
    //     }
    // }

    resetPassword = () => {
        if (this.isValidateAllFields()) {
            let request = this.state.passwordDetails;
            request.adminID = this.state.adminId;
            this.setState({ isLoading: true });
            this.adminServices.resetPassword(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    this.swalServices
                        .SuccessWithAction("Password has been changed successfully. Please login again with your new password.", "Ok")
                        .then((response) => {
                            this.setState({ route: "/Login" });
                        });
                    this.setState({ isLoading: true });
                }
                else {
                    this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
            })
        }
    }

    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.passwordDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
    };

    isValidateAllFields = () => {
        const newValidState = isValidForm(
            this.state.passwordDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let details = this.state.passwordDetails;
        details[name] = value;
        this.setState({ passwordDetails: details });
    }

    render() {
        if (this.state.route !== "") {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div>
                <div className="main-login-sec">
                    <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 w-full">
                        <div className="login-main-bg">
                            <div className="">
                                <img
                                    className="mx-auto w-[280px]"
                                    src="/logo.png"
                                    alt="logo"
                                />
                                <h2 className="main-login-title">
                                    New Password

                                </h2>
                            </div>
                            <input type="hidden" name="remember" value="true" />
                            <div className="rounded-md relative">
                                <div className='mb-4'>
                                    <label htmlFor="new-password" className='login-label'>
                                        Enter New Password
                                    </label>
                                    <div className="relative mt-2">
                                        <input
                                            id="new-password"
                                            name="password"
                                            type={this.state.showPassword ? "text" : "password"}
                                            autoComplete="new-password"
                                            required
                                            className="login-input pr-10"
                                            placeholder="Password"
                                            value={this.state.passwordDetails.password}
                                            onChange={(event) => this.handleChange(event)}
                                            onBlur={() => this.validateField("password")}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                                            onClick={() => this.setState((prevState) => ({ showPassword: !prevState.showPassword }))}
                                            aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                                        >
                                            <Icon icon={this.state.showPassword ? "mdi:eye-off" : "mdi:eye"} />
                                        </button>
                                    </div>
                                    <ValidationText
                                        className="absolute left-0 top-[100%]"
                                        error={this.state.validState.error.password}
                                    />
                                </div>

                                <div className='mb-4'>
                                    <label htmlFor="confirm-password" className='login-label'>
                                        Confirm  New Password
                                    </label>
                                    <div className="relative mt-2">
                                        <input
                                            id="confirm-password"
                                            name="confirmPassword"
                                            type={this.state.showConfirmPassword ? "text" : "password"}
                                            autoComplete="new-password"
                                            required
                                            className="login-input pr-10"
                                            placeholder="Confirm Password"
                                            value={this.state.passwordDetails.confirmPassword}
                                            onChange={(event) => this.handleChange(event)}
                                            onBlur={() => this.validateField("confirmPassword")}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                                            onClick={() => this.setState((prevState) => ({ showConfirmPassword: !prevState.showConfirmPassword }))}
                                            aria-label={this.state.showConfirmPassword ? "Hide password" : "Show password"}
                                        >
                                            <Icon icon={this.state.showConfirmPassword ? "mdi:eye-off" : "mdi:eye"} />
                                        </button>
                                    </div>
                                    <ValidationText
                                        className="absolute left-0 top-[100%]"
                                        error={this.state.validState.error.confirmPassword}
                                    />
                                </div>


                            </div>

                            <div className="flex justify-center">
                                {this.state.isLoading ? (
                                    <ButtonLoader className="loader-btn" />
                                ) : (


                                    <button
                                        type="submit"
                                        className="submit-login-btn"
                                        onClick={() => this.resetPassword()}
                                    >
                                        <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                                            <svg
                                                className="h-5 w-5 text-rose-300 group-hover:text-rose-100"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="#ffff"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </span>
                                        Continue
                                    </button>

                                )}
                            </div>

                            <div className="text-center mt-4">
                                <a
                                    href="/Login"
                                    className="font-medium text-[#329a03] hover:text-[#297407] text-sm"
                                >
                                    Back to Login
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
